export const selectTasksState = (state) => state.tasks;
export const selectTasksReactions = (state) => state.tasks.reactions;
